import { Box, HStack, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiXCircle } from "react-icons/fi";
import type { SupplierBidRejectionDto } from "../../../../autogen/bff-api";
import { useDisplayDateWithTime } from "../../../../common/formatting/useDisplayDateWithTime";
import { RejectionDetails } from "../../../../common/rejection/RejectionDetails";
import { REJECTION_COMPLAINT_INFO } from "../../../../common/rejection/rejectionMessage";
import { useDesignContestEntry } from "./designContestEntry";

interface Props {
  rejection?: SupplierBidRejectionDto | null;
  buyerRunsPublicProcurements: boolean;
  outsideProcurementAct?: boolean;
}

export const BidRejectionCard = ({ rejection, buyerRunsPublicProcurements, outsideProcurementAct = false }: Props) => {
  const { t } = useTranslation();
  const designContest = useDesignContestEntry();
  const displayDateWithTime = useDisplayDateWithTime();
  return (
    <Box
      as="section"
      aria-label={(designContest ? t("Your entry was rejected") : t("Your bid was rejected")) ?? undefined}
      borderWidth="1px"
      borderColor="smBorder"
      bg="smBackground"
      rounded="xl"
      px={{ base: "4", md: "6" }}
      py="4"
    >
      <Stack spacing="4">
        <Stack spacing="1">
          <HStack spacing="2">
            <Icon as={FiXCircle} color="smError" boxSize="5" aria-hidden />
            <Text fontWeight="semibold" color="smText">
              {designContest ? t("Your entry was rejected") : t("Your bid was rejected")}
            </Text>
          </HStack>
          {rejection?.rejectedAt && (
            <Text fontSize="sm" color="smMuted">
              {t("Sent {{time}}", { time: displayDateWithTime(rejection.rejectedAt) })}
            </Text>
          )}
        </Stack>
        {rejection ? (
          <RejectionDetails
            grounds={rejection.grounds}
            reason={rejection.reason}
            message={rejection.message}
            attachments={rejection.attachments}
            attachmentIds={rejection.attachmentIds}
          />
        ) : (
          <>
            <Text fontSize="sm" color="smText">
              {t("The buyer gave no reason with the rejection.")}
            </Text>
            {buyerRunsPublicProcurements && !outsideProcurementAct && (
              <Text fontSize="sm" color="smMuted">
                {REJECTION_COMPLAINT_INFO}
              </Text>
            )}
          </>
        )}
      </Stack>
    </Box>
  );
};
